import domHelper from '../base/DomHelper';
import CollapsedPanel from './CollapsedPanel';

export const LAYOUT_TEMPLATE = `
<div ref="layoutRef" :class="layoutClasses" :style="layoutStyles" @click="onClick($event)">
    <slot></slot>
    <CollapsedPanel v-for="region in ['west','east','north','south']" 
        bodyCls="f-column f-vcenter"
        :key="region"
        :region="region" 
        :title="collapseTitle(region)" 
        :collapsible="true" 
        :collapseIconCls="collapseIconCls(region)"
    >
        <template v-if="region=='west' || region=='east'">
            <div class="f-vtitle f-full">{{getPanel(region)?getPanel(region).title:null}}</div>
        </template>
    </CollapsedPanel>
</div>
`;

export default {
    name: 'Layout',
    template: LAYOUT_TEMPLATE,
    components: {
        CollapsedPanel,
    },
    props: {
        layoutCls: String,
        layoutStyle: Object
    },
    data() {
        return {
            panels: [],
            paddings: null,
            paddingLeft: 0,
            paddingRight: 0,
            paddingTop: 0,
            paddingBottom: 0
        }
    },
    computed: {
        layoutClasses(){
            return ['layout', this.layoutCls];
        },
        layoutStyles(){
            return [this.layoutStyle, {padding:this.paddings}];
        }
    },
    watch: {
        panels(){
            this.updatePaddings();
            this.$nextTick(() => this.updatePaddings());
        }
    },
    created() {
        if (window.EventHub){
            window.EventHub.$on('tabSelect', (tab) => {
                if (domHelper.isChild(this.$el, tab.$el)){
                    this.updatePaddings();
                }
            });
            window.EventHub.$on('panelSelect', (panel) => {
                if (domHelper.isChild(this.$el, panel.$el)){
                    this.updatePaddings();
                }
            });
        }
    },
    methods: {
        addPanel(panel){
            this.panels.push(panel);
        },
        removePanel(panel){
            let index = this.panels.indexOf(panel);
            if (index >= 0){
                this.panels.splice(index,1);
            }
        },
        getPanel(region){
            let pp = this.panels.filter(p => p.region == region);
            return pp.length ? pp[0] : null;
        },
        getPaddingValue(region) {
            let panel = this.getPanel(region);
            if (!panel){
                return 0;
            }
            let val = 0;
            if (panel.collapsedState){
                if (panel.expander){
                    val += panel.collapsedSize - 1;
                }
            } else {
                if (panel.float){
                    if (panel.expander){
                        val += panel.collapsedSize - 1;
                    }
                } else {
                    if (region == 'west' || region == 'east'){
                        val = domHelper.outerWidth(panel.$el);
                    } else {
                        val = domHelper.outerHeight(panel.$el);
                    }
                    if (!panel.split && panel.border){
                        val -= 1;
                    }
                }
            }
            return val;
        },
        updatePaddings() {
            this.paddingLeft = this.getPaddingValue('west');
            this.paddingRight = this.getPaddingValue('east');
            this.paddingTop = this.getPaddingValue('north');
            this.paddingBottom = this.getPaddingValue('south');
            this.paddings = [this.paddingTop, this.paddingRight, this.paddingBottom, this.paddingLeft].map(v => v + 'px').join(' ');
            this.$emit('resize')
        },
        onClick(event){
            let cp = domHelper.closest(event.target, '.layout-panel');
            this.panels.filter(p => p.$el != cp).forEach(p => {
                if (p.isExpanding){
                    return;
                }
                if (p.float && !p.collapsedState){
                    p.collapse();
                }
            });
        },
        collapseTitle(region){
            if (region == 'west' || region == 'east'){
                return ' ';
            }
            const panel = this.getPanel(region);
            return panel ? panel.title : null;
        },
        collapseIconCls(region){
            const iconMap = {
                'east':'left',
                'west':'right',
                'north':'down',
                'south':'up'
            };
            return 'layout-button-' + iconMap[region];
        },
        collapsedSize(region){
            const panel = this.getPanel(region);
            return panel ? panel.collapsedSize : null;
        }
            
    }
}